import React from 'react';
import { useLoopingCountdown } from '../hooks/useLoopingCountdown';
const START_SECONDS = 17 * 60 + 34;
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown(START_SECONDS);
  const units = [{
    label: 'Hours',
    value: hours
  }, {
    label: 'Minutes',
    value: minutes
  }, {
    label: 'Seconds',
    value: seconds
  }];
  return <div className="w-full max-w-md" role="timer" aria-live="off" data-id="element-79" data-mp="3pzaw96nfystq">
      <p className="text-center text-sm font-bold uppercase tracking-wide text-danger" data-id="element-80" data-mp="3c0b77xw0obx1">This offer expires in</p>
      <div className="mt-2 flex items-center justify-center gap-2" data-id="element-81" data-mp="3gyw5vsvmenjd">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-82" data-mp="325t00ire5y8h" data-mpi={i}>
            <div className="flex w-20 flex-col items-center rounded-xl bg-navy py-2 text-white" data-id="element-83" data-mp="3729mz9muu6jz">
              <span className="font-display text-4xl font-extrabold tabular-nums leading-none" data-id="element-84" data-mp="10btqo2xtxqyf">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-white/70" data-id="element-85" data-mp="159279z3bxmxk">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="font-display text-3xl font-extrabold text-navy" data-id="element-86" data-mp="t1ai3e53ykcq">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}